var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"serach","clearable":"","placeholder":_vm.$t('Home.helpCenter.MobileSerachHead.SearchTutorialOrFAQ'),"prefix-icon":"el-icon-search"},on:{"change":_vm.handleSearch},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }